import { HttpHeaders } from '@angular/common/http';
import { RefdataService } from './refdata.service';
import { Input, OnChanges, ElementRef, Renderer2, Directive } from '@angular/core';


@Directive({
  selector: '[appReq]'
})
export class RequiredDirective implements OnChanges {

  @Input() carrier: string;
  @Input() path: string;

  constructor(private el: ElementRef, private renderer: Renderer2, private refdata: RefdataService) {
    // this.updateRequiredState();
  }

  ngOnChanges(changes: any) {
    // console.debug('appreq ' + changes.appReq + ' carrier: ' + JSON.stringify(changes.carrier));
    if (changes.appReq || changes.carrier || changes.path) {
      this.updateRequiredState();
    }
  }


  parseFilter(s: string): any {
    const rv = [];
    s.split(',').forEach(item => {
      const pair = item.split('=');
      if (pair.length > 1) {
        rv[pair[0]] = pair[1];
      }
    });
    return rv;
  }

  
  markElement(req: boolean) {
    if (this.el.nativeElement.required) {
      this.el.nativeElement.required = req;
    }
    else if (req) {
      this.renderer.addClass(this.el.nativeElement, 'required');
    }
    else if (!req) {
      this.renderer.removeClass(this.el.nativeElement, 'required');
    }
  }

  updateRequiredState() {
    let id = this.el.nativeElement.getAttribute('id');
    if (!id) {
      id = this.el.nativeElement.getAttribute('name');
    }
    if (!id) {
      id = this.el.nativeElement.getAttribute('for');
    }

  }
}
